import { render, staticRenderFns } from "./SetsReport.vue?vue&type=template&id=bfc4732c&scoped=true&"
import script from "./SetsReport.vue?vue&type=script&lang=js&"
export * from "./SetsReport.vue?vue&type=script&lang=js&"
import style0 from "./SetsReport.vue?vue&type=style&index=0&id=bfc4732c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc4732c",
  null
  
)

export default component.exports